import { useNavigate } from 'react-router-dom'
import { cn } from '@/lib/cn'
import { ArrowLeftIcon } from '@/components/ui/icons'

interface BackLinkProps {
  /** Destino quando não há histórico para voltar (acesso direto via link). */
  fallbackTo?: string
  label?: string
  className?: string
}

/** Link "← Voltar" usado no topo das páginas internas. */
export function BackLink({ fallbackTo = '/', label = 'Voltar', className }: BackLinkProps) {
  const navigate = useNavigate()

  return (
    <button
      type="button"
      onClick={() => {
        if (window.history.length > 1) navigate(-1)
        else navigate(fallbackTo)
      }}
      className={cn(
        'inline-flex items-center gap-2 text-sm text-ink transition-colors hover:text-brand',
        className,
      )}
    >
      <ArrowLeftIcon className="size-[18px]" />
      {label}
    </button>
  )
}
